<template>
  <div class="generalBarContainer">
    <div class="contentSearchAndBtnSeeAll">
      <div class="dates">
        <div class="dateWithPeriod" v-if="enableDates">
          <div class="textPeriod">
            <p>Período</p>
          </div>

          <p style="margin: 0; position: absolute; top: -17px; left: 77px">
            Inicial
          </p>

          <input
            type="date"
            :class="`borderInputDate ${isInvalidInput}${
              isDisabled && 'inputDisabled'
            }`"
            v-model="valueInputStartDate"
            @input="selectedStartDateValue"
          />
        </div>

        <div class="dateWithoutPeriod" v-if="enableDates">
          <p style="margin: 0; position: absolute; top: -17px; left: 0">
            Final
          </p>

          <input
            type="date"
            :style="enableDates && `border-radius: 5px`"
            :class="`borderInputDate ${isInvalidInput}${
              isDisabled && 'inputDisabled'
            }`"
            v-model="valueInputEndDate"
            @input="selectedEndDateValue"
          />
        </div>
      </div>
      <div class="search">
        <b-form-select
          v-if="enableFilters"
          class="searchFilter"
          size="sm"
          v-model="valueItems"
          @change="selectFilterType"
          :text-field="textField"
          :value-field="valueField"
          :options="items"
        ></b-form-select>

        <div class="contentInputButton">
          <b-form-select
            v-if="inputSearchIsSelect"
            :class="`${inputSearchIsSelect && 'inputSearchIsSelect'} ${
              !enableFilters && 'borderLeft'
            } borderInput spaceBetweenButton ${isInvalidInput}${
              isDisabled && 'inputDisabled'
            }  text-center`"
            size="sm"
            v-model="valueItemsTypes"
            @change="selectTypes"
            :text-field="textField"
            :value-field="valueField"
            :options="itemsTypes"
            ref="refTypes"
          ></b-form-select>

          <input
            v-else
            :style="`${!enableFilters && 'border-radius: 5px'}; ${
              !enableBtnSeeAll ? 'width: calc(100% - 20px)' : 'width: 100%'
            }`"
            :class="`borderInput spaceBetweenButton ${isInvalidInput}${
              isDisabled && 'inputDisabled'
            }`"
            v-model="valueInput"
            @input="selectedInputValue"
            :placeholder="placeholder"
            @blur="clearInvalidInput"
            ref="refInput"
            v-mask="maskCpfCnpj(mask)"
          />

          <b-button size="sm" class="searchBtn" @click="handleClickIconSearch">
            <b-icon-search class="searchIcon" />
          </b-button>
        </div>
      </div>

      <div class="contentBtnSeeAll" v-if="enableBtnSeeAll">
        <button class="btnSeeAll" @click="handleClickSeeAll">Ver tudo</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enableFilters: {
      type: Boolean,
      default: false,
    },
    enableDates: {
      type: Boolean,
      default: false,
    },
    enableBtnSeeAll: {
      type: Boolean,
      default: false,
    },
    inputSearchIsSelect: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
    },
    itemsTypes: {
      type: Array,
    },
    valueField: {
      type: String,
    },
    textField: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
    },
    backgroundInput: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    isInvalidInput: {
      type: String,
    },
    isCpfCnpj: {
      type: Boolean,
      default: false,
    },
    clickIconSearch: {
      type: [Function],
    },
    clickSeeAll: {
      type: Function,
    },
    refInput: {
      type: String,
    },
    mask: {
      type: [String, Number, Boolean],
    },
  },
  data() {
    return {
      valueItems: "",
      valueItemsTypes: "",
      valueInput: "",
      valueInputStartDate: "",
      valueInputEndDate: "",
    };
  },
  methods: {
    selectFilterType() {
      this.$emit("selectFilterType", this.valueItems);
      this.$emit("changedFilter");
      this.valueItemsTypes = "";
      this.valueInput = "";
    },
    selectTypes() {
      this.$emit("selectTypes", this.valueItemsTypes);
    },
    selectedInputValue() {
      this.$emit("getInputvalue", this.valueInput);
    },
    selectedStartDateValue() {
      this.$emit("getInputStartDateValue", this.valueInputStartDate);
    },
    selectedEndDateValue() {
      this.$emit("getInputEndDateValue", this.valueInputEndDate);
    },
    clearInvalidInput() {
      this.$emit("clearInvalidInput");
    },
    handleClickSeeAll() {
      if (this.clickSeeAll) return this.clickSeeAll();

      return;
    },
    handleClickIconSearch() {
      if (this.clickIconSearch) return this.clickIconSearch();

      return;
    },
    maskCpfCnpj(value) {
      if (this.isCpfCnpj) {
        if (!value) {
          return "";
        }
        if (value?.length <= 14) {
          return "###.###.###-##";
        }
        if (value?.length > 14) {
          return "##.###.###/####-##";
        } else {
          return "";
        }
      }
    },
  },
};
</script>

<style scoped>
.generalBarContainer {
  width: 100%;
  display: flex;
  gap: 2rem;
}

.search {
  display: flex;
}

.dates {
  display: flex;
  gap: 1rem;
}

.borderInputDate {
  width: 100%;
  font-size: 12px;
  height: 30px;
  border: 1px solid #e3e0e0;
  color: #5c5855;
  border-radius: 0 5px 5px 0;
  cursor: text;
  box-shadow: none !important;
  padding: 0.25rem;
  outline: none !important;
}

.borderInput {
  width: 100%;
  font-size: 12px;
  height: 30px;
  border: 1px solid #e3e0e0;
  color: #5c5855;
  border-radius: 0;
  cursor: text;
  box-shadow: none !important;
  padding: 0.25rem;
  outline: none !important;
}

.spaceBetweenButton {
  padding: 0.25rem 2.3rem 0.25rem 0.5rem;
}

.inputDisabled {
  background-color: #fafafa !important;
  pointer-events: none !important;
  color: #949290 !important;
}

.iconDisabled {
  pointer-events: none !important;
}

.fixedSelectDisable {
  padding: 0 !important;
}

input:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

button:focus {
  box-shadow: none;
}

button:hover {
  background: whitesmoke !important;
  border: 1px solid #e3e0e0;
}

.searchIcon {
  color: black;
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s !important;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

.searchBtn {
  height: 30px;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none !important;
  background-color: whitesmoke !important;
  border-color: #e3e0e0;
  border: 1px solid #e3e0e0;
  -moz-appearance: none !important;
  appearance: none !important;
}

.searchBtn:focus {
  border-color: #e3e0e0 !important;
}

.searchFilter {
  width: auto;
  height: 30px;
  font-size: 11px;
  text-align: center;
  border-radius: 5px 0 0 5px;
  border: 1px solid #e3e0e0;
  border-right: none;
  -moz-appearance: none !important;
  appearance: none !important;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0 !important;
  border-right: none !important;
}

.dateWithPeriod {
  display: flex;
  position: relative;
}

.dateWithoutPeriod {
  position: relative;
}

.textPeriod {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 30px;
  padding: 0 1rem;
  font-size: 11px;
  border-radius: 5px 0 0 5px;
  border: 1px solid #e3e0e0;
  border-right: none;
  cursor: default;
}

.contentInputButton {
  width: 100%;
  display: flex;
}

.borderLeft {
  border-radius: 5px;
}

.inputSearchIsSelect {
  width: calc(100% - 20px);
  min-width: 205.8px;
}

.btnSeeAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  width: 150px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
}

.btnSeeAll:hover {
  background: rgb(205, 205, 205);
  transition: ease-in all 0.1s;
}

.contentSearchAndBtnSeeAll {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
}

p {
  margin: 0;
  padding: 0;
}

@media screen and (min-width: 1015px) {
  input[type="date"] {
    max-width: 150px;
  }
}

@media screen and (max-width: 1200px) {
  .generalBarContainer {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}

@media screen and (max-width: 1187px) {
  .search {
    width: 100% !important;
    margin-right: 1rem;
  }

  .inputSearchIsSelect {
    width: 100%;
    min-width: 100% !important;
  }

  .contentSearchAndBtnSeeAll {
    gap: 2rem;
  }
}

@media screen and (max-width: 1014px) {
  .search {
    width: 100%;
  }

  .generalBarContainer {
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 0;
  }

  .dateWithPeriod,
  .dateWithoutPeriod {
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  .contentSearchAndBtnSeeAll {
    flex-direction: column;
    gap: 1rem;
  }

  .search {
    width: calc(100% - 34.5px) !important;
    margin: 0;
  }

  .contentBtnSeeAll,
  .btnSeeAll {
    width: 100%;
    height: 30px;
  }

  .dates {
    flex-direction: column;
  }

  .generalBarContainer {
    padding-left: 0;
    padding-right: 0;
  }

  input[type="date"] {
    width: 100% !important;
  }
}
</style>